import axios from "../axios-auth";
import orginal_axios from "axios";


export const customerCreditBalanceReportService = {
  getCustomerCreditBalanceReport,
  getCustomerCreditBalanceReportDetail,
  exportCustomerCreditBalanceReportExcel,
};

function getCustomerCreditBalanceReport(searchParams, page, size) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }

  let params = {
    page: page,
    size: size
  };

  if (searchParams.month) {
    params["month"] = searchParams.month;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.saleTeamId) {
    params["saleTeamId"] = searchParams.saleTeamId;
  }
  if (searchParams.accountIds) {
    params["accountIds"] = searchParams.accountIds.join();
  }
  return axios.get("/auth/customer-credit-balance-report", { params });
}

function getCustomerCreditBalanceReportDetail(searchParams, page, size) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }

  let params = {
    page: page,
    size: size
  };

  if (searchParams.month) {
    params["month"] = searchParams.month;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.accountId) {
    params["accountId"] = searchParams.accountId;
  }
  return axios.get("/auth/customer-credit-balance-report-detail", { params });
}

function exportCustomerCreditBalanceReportExcel(searchParams) {
  let params = {};
  if (searchParams.month) {
    params["month"] = searchParams.month;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.saleTeamId) {
    params["saleTeamId"] = searchParams.saleTeamId;
  }
  if (searchParams.accountIds) {
    params["accountIds"] = searchParams.accountIds.join();
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/customer-credit-balance-report-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}
